import { render, staticRenderFns } from "./BrainTool.vue?vue&type=template&id=450576a7&scoped=true"
import script from "./BrainTool.vue?vue&type=script&lang=ts"
export * from "./BrainTool.vue?vue&type=script&lang=ts"
import style0 from "./BrainTool.vue?vue&type=style&index=0&id=450576a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450576a7",
  null
  
)

export default component.exports